<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <hm-alert />
        <hm-policy :policy="policy" :editable="false" />
        <div ref="policyslot" />
        <hr />
        <div class="text-muted">Approved: {{policy.createdAt|formatDate('YYYY-MM-DD HH:MM:SS')}} in HIPAAMATE</div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { policyService } from '@/services'

export default {
  name: 'Print.PolicyPrint',
  props: ['id'],
  data() {
    return {
      policy: {
        id: '',
        data: {}
      },
      ready: false,
      busy: false,
      submitted: false
    }
  },
  methods: {
    ...mapActions({
      alertError: 'alert/error',
      alertException: 'alert/exception'
    }),
    onLoad() {
      this.ready = false;

      if (this.id) {
        policyService.getPolicy(this.id)
          .then(data => {
            // set any defaults that are missing from data to the default values
            this.policy = { ...this.$options.data.apply(this).policy, ...data };
          })
          .catch(err => {
            this.alertException({ err, message: 'Error loading policy.' });
          }).finally(() => {
            this.ready = true;
          });
      } else {
        this.alertError('Invalid policy.');
        this.ready = true;
      }
    }
  },
  created() {
    return this.onLoad();
  },
  watch: { // you have to use function syntax here, as warned in the docs
    '$route.params.id': function (newVal, oldVal) {
      this.onLoad();
    }
  }
}
</script>
